import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * Metadata args utility functions.
 */
export var MetadataUtils = /*#__PURE__*/function () {
  function MetadataUtils() {
    _classCallCheck(this, MetadataUtils);
  }
  _createClass(MetadataUtils, null, [{
    key: "getInheritanceTree",
    value:
    /**
     * Gets given's entity all inherited classes.
     * Gives in order from parents to children.
     * For example Post extends ContentModel which extends Unit it will give
     * [Unit, ContentModel, Post]
     */
    function getInheritanceTree(entity) {
      var tree = [entity];
      var getPrototypeOf = function getPrototypeOf(object) {
        var proto = Object.getPrototypeOf(object);
        if (proto && proto.name) {
          tree.push(proto);
          getPrototypeOf(proto);
        }
      };
      getPrototypeOf(entity);
      return tree;
    }
    /**
     * Checks if this table is inherited from another table.
     */
  }, {
    key: "isInherited",
    value: function isInherited(target1, target2) {
      return target1.prototype instanceof target2;
    }
    /**
     * Filters given array of targets by a given classes.
     * If classes are not given, then it returns array itself.
     */
  }, {
    key: "filterByTarget",
    value: function filterByTarget(array, classes) {
      if (!classes) return array;
      return array.filter(function (item) {
        return item.target && classes.indexOf(item.target) !== -1;
      });
    }
  }]);
  return MetadataUtils;
}();